import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentBandeau from "../../components/layout/ComponentBandeau";
import ComponentSousmenu from "../../components/layout/ComponentSousmenu";
import { apiGetPersonnes } from "../../api/ApiPersonnes";
import { apiGetProcesses } from "../../api/ApiProcess";
import {
  apiGetLastContribByUsers,
  apiRecupEvenementsColidee,
  apiGetAllContribByUsersByEspaces,
} from "../../api/ApiColidee";
import { CardGroup, Container } from "react-bootstrap";
import PersonneCardList from "../../components/public/personne/PersonneCardList";
import BlocFiltresPersonnes from "../../components/public/personne/BlocFiltresPersonnes";
import ComponentSousTitle from "../../components/layout/ComponentSousTitle";
import BlocEvenementsThumbnail from "../../components/public/colidee/BlocEvenementsThumbnail";
import { toDateParseTCompact, toDateCompactFR } from "../../utils/datesHeures";
import PersonneCard from "../../components/public/personne/PersonneCard";
import BlocToggle from "../../components/layout/ComponentToggle";
import BlocFiltreInSocial from "../../components/public/social/BlocFiltreInSocial";
import { chgEvenementFilter, selectInSocialFilters } from "../../redux/ReduxFilter";

import { chgSocialToggle, selectInSocialToggle } from "../../redux/ReduxToggle";

const PageInsocial = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [personnes, setPersonnes] = useState([]);
  const [filterPersonnes, setFilterPersonnes] = useState([]);
  const [infoView, setInfoView] = useState(false);
  const [contributions, setContributions] = useState([]);
  const [allContributions, setAllContributions] = useState([]);
  const [evenements, setEvenements] = useState(0);
  const [datasSortedDateEventEmbauche, setDatasSortedDateEventEmbauche] = useState([]);
  const dispatch = useDispatch();
  const _selectInSocialFilters = useSelector(selectInSocialFilters);

  const [anteriorite, setAnteriorite] = useState(31);
  const [viewToggle, setViewToggle] = useState(useSelector(selectInSocialToggle));

  const switchView = () => {
    dispatch(chgSocialToggle(!viewToggle));
    setViewToggle(!viewToggle);
  };

  useEffect(() => {
    recupPersonnes();
    recupEvenements();

    const params = new URL(window.location).searchParams;
    if (params.get("name")) {
      dispatch(chgEvenementFilter(false));
    }
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (viewToggle) {
      classementDatePersonnesEvenements();
    }
  }, [viewToggle, anteriorite, personnes]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupPersonnes = async () => {
    const res = await apiGetPersonnes(
      ReduxInstance._id,
      "include=orgUnitsParent,marque,localisations"
    );

    if (res) {
      setFilterPersonnes(res.data);
      setPersonnes(res.data);

      if (ReduxInstance.espacePrincipalColidee !== 0) {
        recupContributions(res.data);
      }

      recupAllContributionsForUsersOnAllEspaces(res.data);
    }
  };

  const recupEvenements = async () => {
    if (ReduxInstance.modulesActives.includes("evenement")) {
      const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
      var listeEspaces = [];
      resProcesses.data.map((process) => (listeEspaces = listeEspaces.concat(process.espaces)));
      listeEspaces = listeEspaces.filter((x, i, a) => a.indexOf(x) === i);

      const form = new FormData();
      form.append("espacesSouhaites", listeEspaces.join(","));

      const resEvenements = await apiRecupEvenementsColidee(ReduxToken, form);
      if (resEvenements.data) {
        setEvenements(resEvenements.data);
      }
    }
  };

  const recupAllContributionsForUsersOnAllEspaces = async (personnesArray) => {
    const myForm = new FormData();

    personnesArray.forEach((element) => {
      myForm.append("email[]", element.email);
    });

    var espacesSouhaites = [];
    const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
    resProcesses.data.map(
      (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces))
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);
    /* Si j'ai un espace RDV missions alors je ne le prends pas en compte pour trouver la derniere contrib sur tous les espaces */
    if (ReduxInstance.espacePrincipalColidee !== 0) {
      espacesSouhaites = espacesSouhaites.filter(
        (item) => parseInt(item) !== parseInt(ReduxInstance.espacePrincipalColidee)
      );
    }

    if (espacesSouhaites.length) {
      myForm.append("espacesSouhaites", espacesSouhaites.join(","));
      const resAllContributions = await apiGetAllContribByUsersByEspaces(ReduxToken, myForm);

      if (resAllContributions.data) {
        personnesArray.forEach((element) => {
          let personneFound = resAllContributions.data.findIndex(function (personneColidee) {
            if (personneColidee.email === element.email) {
              return true;
            }
            return false;
          });
          if (personneFound === -1) {
            resAllContributions.data.push({
              email: element.email,
              contribution: "Non renseigné",
            });
          }
        });

        setAllContributions(resAllContributions.data);
      } else {
        console.log("error");
      }
    }
  };

  const recupContributions = async (personnesArray) => {
    if (ReduxInstance.espacePrincipalColidee) {
      const myForm = new FormData();
      myForm.append("espacePrincipalColidee", ReduxInstance.espacePrincipalColidee);
      personnesArray.forEach((element) => {
        myForm.append("email[]", element.email);
      });

      const res = await apiGetLastContribByUsers(ReduxToken, myForm);
      if (res.data) {
        personnesArray.forEach((element) => {
          let personneFound = res.data.findIndex(function (personneColidee) {
            if (personneColidee.email === element.email) {
              return true;
            }
            return false;
          });
          if (personneFound === -1) {
            res.data.push({
              email: element.email,
              contribution: "Non renseigné",
            });
          }
        });

        setContributions(res.data);
      } else {
        console.log("error");
      }
    }
  };

  const BlocEvenement = () => {
    return (
      <CardGroup className="overflowContent" id={"overflowEvenement"}>
        {evenements.map((evenement, index) => (
          <BlocEvenementsThumbnail evenementObject={evenement} key={index} />
        ))}
      </CardGroup>
    );
  };

  const classementDatePersonnesEvenements = () => {
    var now = new Date();
    // on calcule la date UNIX 30 jours avant

    var nomMoinsAnteriorite = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - anteriorite
    );

    var nomMoinsEnCours = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    /* on calcule la date de l'anteriorite pour pouvoir la comparer à la date de l'event et à la date d'embauche */
    var dateAnteriorite =
      nomMoinsAnteriorite.getFullYear() +
      "" +
      ("0" + (nomMoinsAnteriorite.getMonth() + 1)).slice(-2) +
      "" +
      ("0" + nomMoinsAnteriorite.getDate()).slice(-2);

    var dateJour =
      nomMoinsEnCours.getFullYear() +
      "" +
      ("0" + (nomMoinsEnCours.getMonth() + 1)).slice(-2) +
      "" +
      ("0" + nomMoinsEnCours.getDate()).slice(-2);

    var classement = [];
    if (personnes) {
      personnes.forEach((item) => {
        if (item.dateEmbauche && toDateParseTCompact(item.dateEmbauche) >= dateAnteriorite) {
          classement.push({
            date: toDateParseTCompact(item.dateEmbauche),
            type: "personne",
            data: item,
          });
        }
      });
    }

    if (evenements) {
      evenements.forEach((item) => {
        /* on affiche les evenements se deroulant dans le futur */
        if (anteriorite <= -1) {
          if (item.date_evenement && toDateCompactFR(item.date_evenement) >= dateJour) {
            classement.push({
              date: toDateCompactFR(item.date_evenement),
              type: "evenement",
              data: item,
            });
          }
        } else {
          if (
            item.date_evenement &&
            toDateCompactFR(item.date_evenement) >= dateAnteriorite &&
            toDateCompactFR(item.date_evenement) <= dateJour
          ) {
            classement.push({
              date: toDateCompactFR(item.date_evenement),
              type: "evenement",
              data: item,
            });
          }
        }
      });
    }

    classement.sort((b, a) => (a.date > b.date ? 1 : b.date > a.date ? -1 : 0));
    setDatasSortedDateEventEmbauche(classement);
  };

  const renderItem = (objet, index) => {
    if (
      objet.type === "personne" &&
      (_selectInSocialFilters.acteur || _selectInSocialFilters.all)
    ) {
      return (
        <React.Fragment key={index}>
          <PersonneCard personne={objet.data} />
        </React.Fragment>
      );
    }

    if (
      objet.type === "evenement" &&
      (_selectInSocialFilters.evenement || _selectInSocialFilters.all)
    ) {
      return (
        <React.Fragment key={index}>
          <BlocEvenementsThumbnail evenementObject={objet.data} />
        </React.Fragment>
      );
    }
  };

  return (
    <>
      <ComponentMenu menuActif="insocial" />
      <div className="containerHeaderBandeau">
        <ComponentBandeau menu="inSocial" isCalendarView={viewToggle} />
        <BlocToggle
          viewToggle={viewToggle}
          switchView={switchView}
          setAnteriorite={setAnteriorite}
          anteriorite={anteriorite}
          max={7}
          min={-1}
          sousMenus={ReduxInstance.sousMenus.filter((item) => item.parent === "inSocial")}
        />
      </div>
      {ReduxInstance.modulesActives.includes("evenement") && <BlocFiltreInSocial />}
      <br /> &nbsp; <br /> &nbsp;
      {/* Affichage des informations par date */}
      {viewToggle && (
        <Container fluid>
          <div className="d-flex flex-wrap justify-content-center justify-content-md-start">
            {datasSortedDateEventEmbauche.map((objet, index) => renderItem(objet, index))}
          </div>
        </Container>
      )}
      {/* Affichage des informations par catégories */}
      {!viewToggle && (
        <>
          {evenements.length > 0 &&
            (_selectInSocialFilters.evenement || _selectInSocialFilters.all) &&
            ReduxInstance.modulesActives.includes("evenement") && (
              <Container fluid>
                <ComponentSousTitle
                  nom={t("public.filtres.filtre4")}
                  overflowID={"overflowEvenement"}
                />
                <BlocEvenement />
              </Container>
            )}

          {personnes.length > 0 &&
            (_selectInSocialFilters.acteur || _selectInSocialFilters.all) && (
              <Container fluid>
                {/* <ComponentSousTitle nom={t("public.filtres.filtre7")} /> */}

                <BlocFiltresPersonnes
                  personnes={personnes}
                  filterPersonnes={filterPersonnes}
                  setFilterPersonnes={setFilterPersonnes}
                  infoView={infoView}
                  setInfoView={setInfoView}
                />

                <h3>
                  {filterPersonnes.length > 0
                    ? filterPersonnes.length
                    : t("public.pageInSocial.titleFilterPersonnesAucun")}{" "}
                  {filterPersonnes.length > 1
                    ? t("public.pageInSocial.titleFilterPersonnesPluriel")
                    : t("public.pageInSocial.titleFilterPersonnesSingulier")}
                </h3>

                <PersonneCardList
                  personnes={filterPersonnes}
                  infoView={infoView}
                  contributions={contributions}
                  allContributions={allContributions}
                />
              </Container>
            )}
        </>
      )}
    </>
  );
};

export default PageInsocial;
